export default __webpack_public_path__ + "static/media/6274 1.a1e4720d.svg";